import React from "react";
import SroRemarks from "./SroRemarks";

export const SroRemark = React.memo((params) => {
  return <SroRemarks params={params} />;
});
